export const T = {
  en_GB: {
    authorizeApp: "Authorize Application",
    clientLookupFailed:
      "We could not verify the application asking for access, so it cannot be approved.",
    theApp: "the application",
    tryAgain: "Try again",
    requestedPermissions: "Requested permissions",
    scopeOpenid: "Verify your identity",
    scopeProfile: "Access your profile information",
    scopeEmail: "Access your email address",
    scopeOfflineAccess: "Stay connected (refresh tokens)",
    approve: "Approve",
    deny: "Deny",
    authError: "Authorization failed. Please try again.",
    missingParams: "Missing authorization parameters",
    authComplete: "Authorization Complete",
    canCloseTab: "You can close this tab and return to",
    accessDenied: "Access Denied",
    deniedMessage: "You denied access. You can close this tab.",
  },
  nb_NO: {
    authorizeApp: "Autoriser applikasjon",
    clientLookupFailed:
      "Vi kunne ikke verifisere applikasjonen som ber om tilgang, så den kan ikke godkjennes.",
    theApp: "applikasjonen",
    tryAgain: "Prøv igjen",
    requestedPermissions: "Forespurte tillatelser",
    scopeOpenid: "Bekreft identiteten din",
    scopeProfile: "Tilgang til profilinformasjonen din",
    scopeEmail: "Tilgang til e-postadressen din",
    scopeOfflineAccess: "Forbli tilkoblet (oppdateringstokens)",
    approve: "Godkjenn",
    deny: "Avslå",
    authError: "Autorisasjon mislyktes. Vennligst prøv igjen.",
    missingParams: "Manglende autorisasjonsparametere",
    authComplete: "Autorisasjon fullført",
    canCloseTab: "Du kan lukke denne fanen og gå tilbake til",
    accessDenied: "Tilgang nektet",
    deniedMessage: "Du nektet tilgang. Du kan lukke denne fanen.",
  },
} as const;
